import { InputLabel, Slider, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, FieldValues, useWatch } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormSlider<T extends FieldValues>({
    control,
    disabled,
    helperText,
    label,
    required,
    value,
}: Readonly<BaseInputProps<T>>) {
    const [sliderValue, setSliderValue] = useState<number>(0);

    const formValue = useWatch({
        control,
        name: value,
    });

    useEffect(() => {
        if (formValue) {
            setSliderValue(formValue ?? 0);
        }
    }, [formValue]);

    return (
        <Controller
            control={control}
            name={value}
            render={({ field: { onBlur, onChange, ref } }) => (
                <Stack>
                    <Stack
                        direction="row"
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mb: 0.5,
                        }}
                    >
                        <InputLabel sx={{ color: 'black', fontWeight: 'medium' }}>{label}</InputLabel>
                        <InputLabel>{formValue} seconds</InputLabel>
                    </Stack>
                    <Slider
                        disabled={disabled}
                        marks
                        max={300}
                        onBlur={onBlur}
                        onChange={(_, newValue) => setSliderValue(newValue as number)}
                        onChangeCommitted={() => onChange(sliderValue)}
                        ref={ref}
                        step={15}
                        value={sliderValue}
                        valueLabelDisplay="auto"
                    />
                    <InputLabel>{helperText}</InputLabel>
                </Stack>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
            }}
        />
    );
}
